module.exports = __webpack_public_path__ + "img/CoItracker.905b760c.png";